import { useGetAppAccessQuery, useGetAppAccessTypeQuery } from '@app/services';
import { AppTrackEvent, useTrackAppSession } from '@common';
import { useEffect } from 'react';
import ActionButtons from './ActionButtons';
import { AppContent } from './AppContent';
import Header from './Header';
import useAppname from './useAppname';

export default function AppPage() {
    const { appName } = useAppname();

    const { data } = useGetAppAccessQuery(appName, {
        skip: !appName,
    });

    const { title } = useGetAppAccessTypeQuery(appName, {
        skip: !appName,
        selectFromResult: ({ data }) => ({
            title: data?.title,
        }),
    });

    useTrackAppSession(AppTrackEvent.AppPageOpened, data?.app?._id, data?.sharing?.name);

    useEffect(() => {
        if (!appName || !title) return;
        document.title = title || appName;
    }, [appName, title]);

    return (
        <div id="app-page">
            <Header
                title={title || appName}
                app={data?.app}
            />

            <AppContent />

            <ActionButtons appInfo={data?.app} />
        </div>
    );
}
